<div id="basemodal-next-session" class="basemodal" *ngIf="shouldShowModal()" [style.display]="'block'">
  <div class="modalcontent">
    <div class="modalbody">
      @if (nextSession(); as session) {
        <div>
          <div class="popup-title" translate>next_session.popup.title</div>
          <div class="popup-illu">
            <div class="popup-illu-inner"></div>
          </div>
          <div class="popup-copy">
            <span translate
              [translateParams]="{
                start: session.start | date :'HH:mm', 
                end: session.end | date :'HH:mm', 
                teacher: session.teacher.user.first_name
              }">
              next_session.popup.text1
            </span>
            <br />
            <span translate>next_session.popup.text2</span>
          </div>
          <button 
            mat-flat-button 
            color="primary"
            class="teamscall-btn" 
            (click)="joinClass()" 
            [disabled]="!isValidProvider()">
            <img src="assets/images/videochat_icon_white.svg" alt="Teams">
            <span translate>teams.btn</span>
          </button>
          <mat-divider class="my-4"></mat-divider>
          <button 
            class="closepopup-btn" 
            (click)="close()" 
            translate>
            next_session.popup.close
          </button>
        </div>
      }
    </div>
  </div>
  <div class="modalbackground"></div>
</div>
